module.exports = __webpack_public_path__ + "img/alert-success-icon.fa9de081.svg";